import React, { useState, useEffect } from 'react';
import SiteService from './SiteService';
import { Box, Chip, FormControl, FormHelperText, InputLabel, MenuItem, Select, Stack } from '@mui/material';

const InvoiceSelector = ({ mainMeterId, setMainMeterId, unAllocated, setSelectedInvoice }) => {


    const [invoices, setInvoices] = useState([]);
    const [invoiceId, setInvoiceId] = useState('');

    useEffect(() => {
        if (!mainMeterId) return;
        const fetchInvoices = unAllocated ?
            SiteService.getUnallocatedInvoices(mainMeterId) :
            SiteService.getInvoicesByMainMeter(mainMeterId);

        fetchInvoices.then((res) => setInvoices(res.data));

    }, [mainMeterId, unAllocated]);

    useEffect(() => {
        if (invoices.length === 1 || (unAllocated && invoices.length > 0)) {
            setInvoiceId(invoices[0].invoiceId);
            setSelectedInvoice(invoices[0]);
        }
    }, [invoices, unAllocated, setSelectedInvoice]);

    const handleChange = (e) => {
        const selectedId = e.target.value;
        setInvoiceId(selectedId);

        const selectedInvoice = invoices.find(invoice => invoice.invoiceId === selectedId);
        setSelectedInvoice(selectedInvoice);
    };

    return (
        <Box>
            {invoices.length === 1 ? (
                <Box display="flex" alignItems="center" mb={2} mt={2} ml={2}>
                    <Stack direction="row" spacing={1}>
                        <Chip
                            label={`Fatura: ${invoices[0].serialNumber} (${invoices[0].startDate} - ${invoices[0].endDate})`}
                            color="primary"
                            variant="outlined"
                        />
                    </Stack>
                </Box>
            ) : (
                <FormControl sx={{ m: 1, minWidth: 120 }} disabled={!mainMeterId}>
                    <InputLabel shrink={!!invoiceId} id="invoice-label">Ana Sayaç Faturası</InputLabel>
                    <Select
                        value={invoiceId}
                        onChange={handleChange}
                        label="Ana Sayaç Faturası"
                    >
                        {invoices.map((invoice, index) => (
                            <MenuItem
                                key={invoice.invoiceId}
                                value={invoice.invoiceId}
                                disabled={unAllocated && index > 0}
                            >
                                {invoice.serialNumber} ({invoice.startDate} - {invoice.endDate})
                            </MenuItem>
                        ))}
                    </Select>
                    <FormHelperText>İşlem yapmak istediğiniz Fatura</FormHelperText>
                </FormControl>
            )}
        </Box>
    );
}

export default InvoiceSelector;
